import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'axios';
import api from '../../../services/API';
import InputMask from 'react-input-mask';
import validarCpf from '../../../utils/validarCpf';
import historico from '../../../services/Historico';
import Header from '../../../components/Loja/Header/index';
import Footer from '../../../components/Loja/Footer/index';
import SelectCidades from '../../../components/Painel/SelectCidades/index';
import GoogleLogin from '../../../components/Loja/GoogleLogin';
import ModalRegulamento from '../../../components/Loja/ModalRegulamento/index';
import { useLocation } from 'react-router-dom';
import FacebookLogin from 'react-facebook-login';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { autenticarParceiroSocial, autenticarParceiro } from '../../../store/modules/autenticacao/actions';
import { useDispatch } from 'react-redux';

export default function CadastrarAcheSeuPintor() {
  const [enviando, setEnviando] = useState(false);
  const [cpf, setCpf] = useState('');
  const [nome, setNome] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [email, setEmail] = useState('');
  const [celular, setCelular] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [lojaPreferida, setLojaPreferida] = useState('');
  const [concordaTermos, setConcordaTermos] = useState(0);
  const [concordaRegulamento, setConcordaRegulamento] = useState(0);
  const [revendas, setRevendas] = useState([]);
  const [modalRegulamento, setModalRegulamento] = useState(false);
  const [indicacao, setIndicacao] = useState('');
  const [indicacaoVendedor, setIndicacaoVendedor] = useState('');
  const [comoFicouSabendo, setComoFicouSabendo] = useState('');
  const [indicacaoLoja, setIndicacaoLoja] = useState('');
  const query = new URLSearchParams(useLocation().search);
  const dispatch = useDispatch();

  const validarCampos = (data) => {
    const entries = Object.entries(data);
    let temNulo = false;
    entries.forEach((param) => {
      if (temNulo) return;
      if ((param[1] === '' || param[1] == 0) && param[0] === 'endCidade') {
        toast.error(`Cidade obrigatório`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        temNulo = true;
        return;
      }
      if ((param[1] === '' || param[1] == 0) && param[0] === 'concordaTermos') {
        toast.error(
          `Você deve concordar com termo de compartilhamento de dados antes de prosseguir`,
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 10000,
          }
        );
        temNulo = true;
        return;
      }
      if (
        (param[1] === '' || param[1] == 0) &&
        param[0] === 'aceitouRegulamento'
      ) {
        toast.error(
          `Você deve concordar com os termos do regulamento antes de prosseguir`,
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 10000,
          }
        );
        temNulo = true;
        return;
      }
      if (
        param[1] === '' &&
        param[0] !== 'endComplemento' &&
        param[0] !== 'telefone' &&
        param[0] !== 'lojaPreferida' &&
        param[0] !== 'cidadeLojaPreferida' &&
        param[0] !== 'estadoLojaPreferida' &&
        param[0] !== 'indicacaoLoja' &&
        param[0] !== 'indicacaoVendedor' &&
        param[0] !== 'comoFicouSabendo' &&
        param[0] !== 'sexo'
      ) {
        const elemento = document.getElementsByName(param[0])[0];
        const placeholder = elemento?.placeholder || param[0];
        toast.error(`${placeholder} obrigatório`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        temNulo = true;
        return;
      }
    });

    return temNulo;
  };

  const buscarCpf = async (cpf) => {
    cpf = cpf.replace(/[^\d]/g, '');
    if (!cpf) return;
    const filtros = {
      cpf,
    };
    const resultado = await api.get(
      `/api/parceiros?filtros=${JSON.stringify(filtros)}`
    );
    if (resultado.data.parceiros.length > 0) {
      toast.error('Pintor já cadastrado', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      setCpf('');
    }
  };

  const validarBuscarCpf = (e) => {
    const cpf = e.target.value;
    if (!cpf) return;
    if (!validarCpf(cpf)) {
      toast.error('CPF não é válido', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      setCpf('');
    } else {
      buscarCpf(cpf);
    }
  };

  const validarTelefoneCelular = async (e) => {
    const valor = e.target.value.replace(/[^\d]/g, '');
    if (!valor) return;
    if (valor.length < 10) {
      toast.error(`${e.target.placeholder} inválido`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      if (e.target.placeholder === 'Telefone') setCelular('');
    }
  };

  const validaIndicacao = async (e) => {
    const Indicacao = e.target.value;
    if (Indicacao) {
      const resultado = await api.post(`/api/indique-ganhe/validate`, {
        indicacao: Indicacao,
      });

      // console.log(resultado);

      if (resultado.data.indicador) {
        // console.log('Indicador OK!');
      } else {
        // console.log('Indicador BAD!');
        setIndicacao('');
        toast.error('Indicador não encontrado', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        return;
      }
    }
  };

  const validarDataNascimento = async (e) => {
    const data = e.target.value.replace(/[^\d]/g, '');

    //Analisando se existe alguma data inserida
    if (!data) return;
    if (data.length != 8) {
      toast.error(`${e.target.placeholder} inválida`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      setDataNascimento('');
      return;
    } else {
      const day = Number(data.substr(0, 2));
      const month = Number(data.substr(2, 2));
      const year = Number(data.substr(4, 4));
      const dataAtual = new Date();
      let idade = dataAtual.getFullYear() - year;

      // console.log(day, month, year, idade);

      if (
        dataAtual.getMonth() + 1 < month ||
        (dataAtual.getMonth() + 1 == month && dataAtual.getDate() < day)
      ) {
        idade--;
      }
      // console.log(day, month, year, idade);

      //Analisando datas inválidas
      const dataUsuario = new Date(year, Number(month) - 1, day);
      if (dataUsuario.valueOf() > dataAtual.valueOf()) {
        toast.error(`${e.target.placeholder} inválida`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        setDataNascimento('');
        return;
      }

      //Analisando se usuário tem menos de 18 anos
      if (idade < 18) {
        toast.error(
          `Você precisa ter 18 anos ou mais para participar do Clube do Pintor`,
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 10000,
          }
        );
        setDataNascimento('');
        return;
      }
    }
  };

  const cadastrarParceiro = async (e) => {
    try {
      e.preventDefault();
      setEnviando(true);
      
      const data = {
        nome,
        cpf,
        celular,
        email,
        dataNascimento,
        senha,
        confirmarSenha,
        lojaPreferida,
        concordaTermos,
        aceitouRegulamento: concordaRegulamento,
        indicacaoVendedor,
        comoFicouSabendo,
        facebookId: query.get('facebookId') || null,
        googleAuthId: query.get('googleAuthId') || null,
        codigo_cadastro: query.get('codigo_cadastro'),
        telefone: null,
        sexo: null,
        endRua: null,
        endNumero: null,
        endComplemento: null,
        endBairro: null,
        endCidade: null,
        endEstado: null,
        endCep: null,
        cidadeLojaPreferida: null,
        estadoLojaPreferida: null,
        indicacaoLoja,
        cadastroAcheSeuPintor: true,
      };

      await validarEmail();
      const temNulo = validarCampos(data);
      if (temNulo) {
        setEnviando(false);
        return;
      }

      data.indicacao = indicacao;
      
      const formatarCampo = (valor, formatador) => valor ? formatador(valor) : valor;
      
      data.endCep = formatarCampo(data.endCep, (cep) => cep.replace(/[^\d]/g, ''));
      data.telefone = formatarCampo(data.telefone, (tel) => tel.replace(/[^\d]/g, ''));
      data.celular = formatarCampo(data.celular, (cel) => cel.replace(/[^\d]/g, ''));
      data.cpf = formatarCampo(data.cpf, (cpf) => cpf.replace(/[^\d]/g, ''));
      data.dataNascimento = formatarCampo(data.dataNascimento, (data) => {
        const limpa = data.replace(/[^\d]/g, '');
        return `${limpa.substring(4)}${limpa.substring(2, 4)}${limpa.substring(0, 2)}`;
      });

      delete data.aceitouRegulamento;
      delete data.confirmarSenha;

      const resultado = await api.post('/api/parceiros', data);

      if (resultado?.data) {
        toast.success('Cadastro realizado com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        
        const cpfLimpo = cpf.replace(/[^\d]/g, '');
        dispatch(autenticarParceiro(cpfLimpo, senha));
      }
    } catch (error) {
      toast.error(error?.response?.data?.erro || 'Erro ao realizar cadastro. Tente novamente.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
    } finally {
      setEnviando(false);
    }
  };

  const validarEmail = async () => {
    if (email && !email.match(/^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i)) {
      setEmail('');
      toast.error(`Email inválido`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }
  };

  const validarCaractereCpf = (e) => {
    const theEvent = e;
    let key = null;
    if (theEvent.type === 'paste') {
      key = window.event.clipboardData.getData('text/plain');
    } else {
      key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  const buscarRevendas = async () => {
    const resultado = await api.get('/api/revendas');
    const dataRevendas = resultado.data.revendas.sort((a, b) => {
      if (a.nomeInput > b.nomeInput) return 1;
      if (a.nomeInput < b.nomeInput) return -1;
      return 0;
    });

    setRevendas(dataRevendas);
  };

  const responseFacebook = (e) => {
    console.log(`responseFacebook`, e);
    dispatch(autenticarParceiroSocial('facebookToken', e.accessToken));
  }

  const responseGoogle = (e) => {
    console.log(`googleAuthentication`, e, { index: 'googleOauth', social_token: e.credential });
    dispatch(autenticarParceiroSocial('googleOauth', e.credential));
  }

  const responseGoogleError = (e) => {
    console.log(`googleAuthentication`, e);
  }

  useEffect(() => {
    document.title = 'Clube Pro Pintor - Cadastrar';
    buscarRevendas();
    setNome(query.get('name') || null)
    setEmail(query.get('email') || null)
  }, []);

  return (
    <>
      {/* Header customizado para Ache Seu Pintor */}
      <header className="header-home-auto" style={{ minHeight: 'auto', height: 'auto', padding: '20px 0' }}>
        <Container className="d-flex flex-column justify-content-center align-items-center text-center h-100 mt-2">
          <div style={{ 
            display: 'flex', 
            width: '100%', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '0 20px',
            gap: window.innerWidth <= 768 ? '20px' : '40px',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
            flexWrap: 'wrap'
          }}>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center',
              flex: '0 1 auto'
            }}>
              <img
                src="/imagens/logo-dark.png"
                alt="Logo Clube Pro Pintor"
                style={{ 
                  maxWidth: window.innerWidth <= 768 ? '80px' : '100px', 
                  width: window.innerWidth <= 768 ? '80px' : '100px',
                  height: 'auto'
                }}
              ></img>
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',
                marginTop: '8px'
              }}>
                <span className="f-10" style={{ 
                  fontSize: window.innerWidth <= 768 ? '10px' : '12px',
                  textAlign: 'center'
                }}>Administrado e Desenvolvido por</span>
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'row', 
                  alignItems: 'center', 
                  justifyContent: 'center'
                }}>
                  <img
                    src="/imagens/logo-smart.svg"
                    alt="Logo Smart"
                    style={{ 
                      width: window.innerWidth <= 768 ? '50px' : '70px',
                      height: 'auto',
                      marginRight: '8px'
                    }}
                  ></img>
                  <span className="f-10 text-nowrap" style={{ 
                    fontSize: window.innerWidth <= 768 ? '10px' : '12px'
                  }}>
                    Clube de Fidelidade
                  </span>
                </div>
              </div>
            </div>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center',
              flex: '0 1 auto',
              color: 'white',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontWeight: 'bold', 
                fontSize: window.innerWidth <= 768 ? '18px' : '24px', 
                fontStyle: 'italic', 
                color: 'white', 
                marginBottom: '8px',
                textAlign: 'center'
              }}>
                Você está se cadastrando<br />no Ambiente SW Pro
              </div>
              <div style={{ 
                marginTop: '12px', 
                fontWeight: 'bold', 
                fontSize: window.innerWidth <= 768 ? '12px' : '14px', 
                color: 'white', 
                marginBottom: '4px',
                textAlign: 'center'
              }}>
                Já tem cadastro? <a href="/login" style={{ 
                  color: 'white', 
                  textDecoration: 'underline'
                }}>Entre na sua conta</a>
              </div>
              <div style={{ 
                fontSize: window.innerWidth <= 768 ? '10px' : '12px', 
                fontStyle: 'italic', 
                color: 'rgba(255,255,255,0.8)', 
                marginTop: '4px',
                textAlign: 'center'
              }}>
                Ou preencha o formulário abaixo
              </div>
            </div>
          </div>
        </Container>
      </header>

      <Container className="d-flex flex-column justify-content-center">
        <Row className="d-flex justify-content-center mt-5 mb-5">
          <Col xs={12} className="d-flex justify-content-center">
            <form className="form" onSubmit={cadastrarParceiro}>

            <div style={{paddingBottom: '14px'}}>
              <h5>FAÇA SEU CADASTRO</h5>
              <label>Insira seus dados para criar sua conta</label>
            </div>

              <Row>
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="nome">Nome Completo *</label>
                  <input
                    id="nome"
                    name="nome"
                    type="text"
                    placeholder="Nome Completo"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                  ></input>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex flex-column" xs={12} sm={6}>
                  <label htmlFor="cpf">CPF *</label>
                  <InputMask
                    id="cpf"
                    name="cpf"
                    type="text"
                    placeholder="CPF"
                    value={cpf}
                    mask="999.999.999-99"
                    onChange={(e) => setCpf(e.target.value)}
                    onBlur={validarBuscarCpf}
                    onKeyPress={validarCaractereCpf}
                  ></InputMask>
                </Col>
                <Col className="d-flex flex-column" xs={12} sm={6}>
                  <label htmlFor="dataNascimento">Data de Nascimento *</label>
                  <InputMask
                    id="dataNascimento"
                    name="dataNascimento"
                    type="text"
                    placeholder="Data de Nascimento"
                    value={dataNascimento}
                    onBlur={validarDataNascimento}
                    onChange={(e) => setDataNascimento(e.target.value)}
                    mask="99/99/9999"
                  ></InputMask>
                </Col>
              </Row>

              <label htmlFor="email">Email *</label>
              <input
                id="email"
                name="email"
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              ></input>

              <Row>
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="celular">Celular *</label>
                  <InputMask
                    id="celular"
                    name="celular"
                    type="text"
                    placeholder="Celular"
                    value={celular}
                    mask="(99) 99999-9999"
                    onChange={(e) => setCelular(e.target.value)}
                    onBlur={validarTelefoneCelular}
                  ></InputMask>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex flex-column" xs={12} sm={6}>
                  <label htmlFor="senha">Senha *</label>
                  <input
                    id="senha"
                    name="senha"
                    type="password"
                    placeholder="Senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                  ></input>
                </Col>
                <Col className="d-flex flex-column" xs={12} sm={6}>
                  <label htmlFor="confirmarSenha">Confirmar Senha *</label>
                  <input
                    id="confirmarSenha"
                    name="confirmarSenha"
                    type="password"
                    placeholder="Confirmar Senha"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                  ></input>
                </Col>
              </Row>
              <Row className="mt-1">
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="indicacao">
                    Você foi indicado por algum Pintor?
                  </label>
                  <input
                    id="indicacao"
                    name="indicacao"
                    type="text"
                    placeholder="Código de Indicação"
                    value={indicacao}
                    onBlur={validaIndicacao}
                    onChange={(e) => setIndicacao(e.target.value)}
                  ></input>
                </Col>
              </Row>
              <Row className="mt-1">
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="indicacao">
                    Você foi indicado por algum vendedor?
                  </label>
                  <input
                    id="indicacaoVendedor"
                    name="indicacaoVendedor"
                    type="text"
                    placeholder="Código do Vendedor"
                    value={indicacaoVendedor}
                    onChange={(e) => setIndicacaoVendedor(e.target.value)}
                  ></input>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="lojaPreferida">
                    Qual loja Sherwin-Williams você mais compra?
                  </label>
                  <select
                    id="lojaPreferida"
                    name="lojaPreferida"
                    value={lojaPreferida}
                    onChange={(e) => {
                      setLojaPreferida(e.target.value);
                      setIndicacaoLoja(e.target.value);
                    }}
                  >
                    <option value="">Selecione...</option>
                    {revendas.map((l, i) => (
                      <option value={l.nomeInput} key={l.nomeInput}>
                        {l.nomeInput}
                      </option>
                    ))}
                  </select>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="outraLoja">
                    Caso não compre em nenhuma loja Sherwin-Williams, escreva o nome da loja que mais compra
                  </label>
                  <input
                    id="outraLoja"
                    name="outraLoja"
                    type="text"
                    placeholder="Digite o nome da loja"
                    value={lojaPreferida}
                    onChange={(e) => setLojaPreferida(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col className="d-flex flex-column" xs={12}>
                  <label htmlFor="comoFicouSabendo">
                    Como ficou sabendo?
                  </label>
                  <select
                    id="comoFicouSabendo"
                    name="comoFicouSabendo"
                    value={comoFicouSabendo}
                    onChange={(e) => setComoFicouSabendo(e.target.value)}
                  >
                    <option value="">Selecione</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Radio">Rádio</option>
                    <option value="Google">Google</option>
                  </select>
                </Col>
              </Row>
              <Row>
                <Col
                  className="d-flex justify-content-center align-items-center mb-3"
                  xs={12}
                >
                  <input
                    className="m-0 f-14"
                    type="checkbox"
                    id="concordaTermos"
                    name="concordaTermos"
                    onClick={(e) =>
                      e.target.checked
                        ? setConcordaTermos(1)
                        : setConcordaTermos(0)
                    }
                  />
                  <label
                    className="m-0 ml-3 f-14 text-justify"
                    htmlFor="concordaTermos"
                  >
                    Concordo em compartilhar meus dados para uso exclusivo da
                    Smart Tecnologia em Vendas S.A. sendo de direito da Smart a
                    transferência destas informações para uso da
                    Sherwin-Williams e empresas afiliadas.
                  </label>
                </Col>
              </Row>
              <Row>
                <Col
                  className="d-flex justify-content-center align-items-center mb-3"
                  xs={12}
                >
                  <input
                    className="m-0 f-14"
                    type="checkbox"
                    id="concordaRegulamento"
                    name="concordaRegulamento"
                    onClick={(e) =>
                      e.target.checked
                        ? setConcordaRegulamento(1)
                        : setConcordaRegulamento(0)
                    }
                  />
                  <label
                    className="m-0 ml-3 f-14 text-justify"
                    htmlFor="concordaRegulamento"
                  >
                    Concordo com os termos deste regulamento.
                    <button
                      className="btn-limpo font-weight-bold"
                      onClick={(e) => {
                        e.preventDefault();
                        setModalRegulamento(true);
                      }}
                    >
                      Consultar Regulamento
                    </button>
                  </label>
                </Col>
              </Row>

              <button className="btn-primario" type="submit">
                {enviando ? `CADASTRANDO...` : `CADASTRAR`}
              </button>
            </form>
          </Col>
        </Row>
      </Container>
      <Footer />
      <ModalRegulamento
        onlyView
        show={modalRegulamento}
        onHide={() => setModalRegulamento(false)}
      />
    </>
  );
} 